import React, { useMemo } from 'react';
import { HStack, VStack } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { useAppSelector } from 'state/hooks';
import PetAvatar from 'shared/components/Avatars/PetAvatar';
import { Heading } from '@televet/kibble-ui/build/components/Heading';

export const AppointmentPet = (): JSX.Element => {
  const {
    appointmentDraft: { selectedPet },
  } = useAppSelector((state) => state.appointmentsModal);

  const petParentDisplayNames = useMemo(() => {
    return selectedPet?.petParents.map((petParent) => `${petParent.firstName} ${petParent.lastName}`).join(', ');
  }, [selectedPet?.petParents]);

  if (!selectedPet) {
    return <Text>No pet selected</Text>;
  }

  return (
    <HStack>
      <PetAvatar
        name={selectedPet.name}
        speciesType={selectedPet.speciesType}
        photoUrl={selectedPet.photoUrl}
        isDeceased={!!selectedPet.isDeceased}
        isActive={!!selectedPet.isActive}
        size="lg"
        hideRightMargin
      />
      <VStack spacing={0} align="flex-start" ml={1}>
        <Heading size="sm" data-testid="appointment-pet-name">
          {selectedPet.name}
        </Heading>
        <Text as="p" size="xs">
          {petParentDisplayNames}
        </Text>
      </VStack>
    </HStack>
  );
};
